import { observer } from 'mobx-react-lite';
import { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import { UserProperty } from '../../../models/userTypes';
import { UserPropertyContext } from '../../../stores/StoreContexts';
import { Action, ActionKind } from '../utils/riskAssessmentReducer';

interface Option {
  label: string;
  value: UserProperty;
}

interface Props {
  property: UserProperty | null;
  dispatch: React.Dispatch<Action>;
}

const PropertySelect = ({ property, dispatch }: Props): JSX.Element => {
  const initialValue = property
    ? ({
        label: property?.property_name,
        value: property
      } as Option)
    : null;

  const userPropertyStore = useContext(UserPropertyContext);
  const [value, setValue] = useState<Option | null>(initialValue);

  // Set options to properties that are 'complete'.
  const options = userPropertyStore.properties
    ?.map((property: UserProperty) => {
      if (!userPropertyStore.isSprayPlanReady(property.id)) return null;
      return {
        label: property.property_name || '',
        value: property
      };
    })
    .filter((option) => option !== null) as Option[] | undefined;

  useEffect(() => {
    setValue(() =>
      property
        ? ({
            label: property?.property_name,
            value: property
          } as Option)
        : null
    );
  }, [property]);

  return (
    <Select
      options={options ? options : []}
      placeholder='Select a Property'
      value={value}
      onChange={(v: Option | null) => {
        if (!v) userPropertyStore.setSelectedProperty(-1);
        else if (v.value.id) userPropertyStore.setSelectedProperty(v.value.id);
        setValue(v);
        dispatch({
          type: ActionKind.SET_PROPERTY,
          payload: (v as Option).value
        });
      }}
    />
  );
};

export default observer(PropertySelect);
